import { render, staticRenderFns } from "./TransferenciaRede.vue?vue&type=template&id=66bea5ef&"
import script from "./TransferenciaRede.vue?vue&type=script&lang=js&"
export * from "./TransferenciaRede.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../front-end/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports